import { IErrorState } from './types';

export const errorInitialState: IErrorState = {
  genericError: {
    error: false,
    title: 'Houve um problema ao carregar informações',
    description: 'Ocorreu um erro inesperado.',
    actionClosedDialog: false,
  },
  connectionState: {
    error: false,
    connectionState: false,
  },
  betaAccessError: {
    error: false,
  },
};
